export const Headings ={
    VEHICLE_NUMBER:"Vehicle Number",
    VEHICLE_TYPE:"Vehicle Type",
    OWNERSHIP_TYPE:"Ownership Type",
    TRUCK_TYPE:"Truck Type",
    TRACKING_TYPE:"Tracking Type",
    GPS_AVAILABLE:"GPS Available",
    NO_OF_DRIVERS:"No Of Drivers",
    DRIVER_NAME:"Driver Name",
    DRIVER_MOBILE_NUMBER:"Driver Mobile Number",
    DRIVER_LICENCE_NUMBER:"Driver Licence Number",
    NETWORK_PROVIDER:"Network Provider",
    VEHICLE_SEAL_NUMBER:"Vehicle Seal No",
    MARKET_VEHICLE: "Market Vehicle",
    ROUTE:'Route',
    CONSIGNOR:"Consignor",
    CONSIGNEE:"Consignee",
    DATE:"Date"
}

export const table_headers = {
    tms_indented_transporter : "TMS Indented Transporter",
    truck_type : "Truck Type",
    consignor : "Consignor",
    consignee : "Consignee",
    agreed_sob : "Agreed SOB %",
    tms_indented_sob : "TMS Indented SOB %",
    actual_sob : "Actual Achieved SOB %"
}